import React from 'react';
import Card from '../components/Card';
import Filters from '../components/Filters';
import { useFavorites } from '../context/FavoritesContext';
import { RouteComponentProps } from 'react-router-dom';
import TagsHoc from '../components/hoc/TagsHoc';
import { useQueryStrings } from '../context/QueryStringContext';
import { useData } from '../context/DataContext';

interface BookmarkPagePropsBase {}

type BookmarkPageProps = BookmarkPagePropsBase & RouteComponentProps;

function BookmarksPage(_props: BookmarkPageProps) {
  const { data } = useData();
  const { favorites, toggleFavorite } = useFavorites();
  const { updateQs } = useQueryStrings();

  return (
    <div id="BookmarksPage">
      <Filters title={data.appConfig.FAVORITES_LABEL} icon={['far', 'heart']} />
      <div className="grid gap-2 pb-8">
        {Object.values(favorites.offers).map(offer => {
          return (
            <TagsHoc type="basic" item={offer} key={offer.id}>
              {props => (
                <Card
                  className="border-b"
                  onClick={() => updateQs('offer', offer.id)}
                  title={offer.title}
                  subtitle={offer.description}
                  image={offer.images[0]?.url}
                  tags={props.tags}
                  isFavorite
                  onFavoriteClick={() => toggleFavorite({ type: 'offers', value: offer })}
                />
              )}
            </TagsHoc>
          );
        })}
        {Object.values(favorites.events).map(evt => {
          return (
            <TagsHoc type="basic" item={evt} key={evt.id}>
              {props => (
                <Card
                  className="border-b"
                  onClick={() => updateQs('event', evt.id)}
                  title={evt.title}
                  subtitle={[evt.venueString, evt.timeString]}
                  image={evt.images[0]?.url}
                  tags={props.tags}
                  isFavorite
                  onFavoriteClick={() => toggleFavorite({ type: 'events', value: evt })}
                />
              )}
            </TagsHoc>
          );
        })}
        {Object.values(favorites.venues).map(venue => {
          return (
            <TagsHoc type="venue" item={venue} key={venue.templateId}>
              {props => (
                <Card
                  className="border-b"
                  onClick={() => updateQs('venue', venue.templateId)}
                  title={venue.venueString}
                  subtitle={venue.timeStrings}
                  image={venue.images?.[0]?.url}
                  tags={props.tags}
                  isFavorite
                  onFavoriteClick={() => toggleFavorite({ type: 'venues', value: venue })}
                />
              )}
            </TagsHoc>
          );
        })}
        {Object.keys(favorites.events).length < 1 &&
          Object.keys(favorites.offers).length < 1 &&
          Object.keys(favorites.venues).length < 1 && (
            <div className="italic text-slate px-4 pt-4 text-center">
              {data.appConfig.NO_FAVORITES_TEXT}
            </div>
          )}
      </div>
    </div>
  );
}

export default BookmarksPage;
